module.exports = __webpack_public_path__ + "static/logo.3c1b6608.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 866
// module chunks = 226573449209678